import _extends from "@babel/runtime/helpers/extends";
export default getCustomComponents;
import React from 'react';
import _ from 'lodash';
import InfoElement from '../InfoElement';
import EXTERNAL_INFO_TYPE from '../../common/constants/externalInfoType';
import renderMasterInfoElements from './renderMasterInfoElements';
import { GALLERY_CONSTS, flatToNested } from 'pro-gallery-lib';
function getCustomComponents(shouldUseNewInfo, galleryWrapperProps, shouldControlHorizontalAlignment, shouldUseLineHeightFixer, shouldInsertDefaults, customInfoRenderer, customHoverRenderer, options) {
  // const simulatedProps = {infoElementsOptions: }
  if (shouldUseNewInfo) {
    ['top', 'middle', 'bottom'].forEach(sectionName => {
      options["infoElementsOptions_external_order_" + sectionName] = options["infoElementsOptions_external_order_" + sectionName].split(',');
      options["infoElementsOptions_internal_order_" + sectionName] = options["infoElementsOptions_internal_order_" + sectionName].split(',');
    });
    const newInfoElementsConfig = _.pick(options, ['infoElementsOptions_external_enabled_Description', 'infoElementsOptions_external_enabled_Title', 'infoElementsOptions_external_enabled_Social', 'infoElementsOptions_external_socialParams_options_allowDownload', 'infoElementsOptions_external_socialParams_options_loveButton', 'infoElementsOptions_external_socialParams_options_allowSocial', 'infoElementsOptions_external_order_bottom', 'infoElementsOptions_external_order_middle', 'infoElementsOptions_external_order_top', 'infoElementsOptions_internal_enabled_Description', 'infoElementsOptions_internal_enabled_Social', 'infoElementsOptions_internal_socialParams_options_allowDownload', 'infoElementsOptions_internal_socialParams_options_loveButton', 'infoElementsOptions_internal_socialParams_options_allowSocial', 'infoElementsOptions_internal_enabled_Title', 'infoElementsOptions_internal_order_bottom', 'infoElementsOptions_internal_order_middle', 'infoElementsOptions_internal_order_top']);
    const nestedInfoConfig = flatToNested(newInfoElementsConfig);
    galleryWrapperProps.infoElementsOptions = {
      newInfoElementsConfig: {
        internal: nestedInfoConfig.infoElementsOptions.internal,
        external: nestedInfoConfig.infoElementsOptions.external,
        externalPlacement: 'external'
      }
    };
  }
  return {
    customInfoRenderer: (pgItemProps, _placement) => {
      if (shouldUseNewInfo) {
        return renderMasterInfoElements(getInternalOrExternal(_placement), {}, galleryWrapperProps, true, pgItemProps, shouldControlHorizontalAlignment, shouldUseLineHeightFixer, shouldInsertDefaults);
      }
      return customInfoRenderer || /*#__PURE__*/React.createElement(InfoElement, _extends({
        infoType: EXTERNAL_INFO_TYPE.EXTERNAL
      }, pgItemProps));
    },
    customHoverRenderer: pgItemProps => {
      if (shouldUseNewInfo) {
        return renderMasterInfoElements(EXTERNAL_INFO_TYPE.HOVER, {}, galleryWrapperProps, true, pgItemProps, shouldControlHorizontalAlignment, shouldUseLineHeightFixer, shouldInsertDefaults);
      }
      return customHoverRenderer || /*#__PURE__*/React.createElement(InfoElement, _extends({
        infoType: EXTERNAL_INFO_TYPE.HOVER
      }, pgItemProps));
    }
  };
}
function getInternalOrExternal(_placement) {
  return _placement === GALLERY_CONSTS.layoutParams_info_placement.OVERLAY ? EXTERNAL_INFO_TYPE.HOVER : EXTERNAL_INFO_TYPE.EXTERNAL;
}
//# sourceMappingURL=getCustomComponents.js.map